import { useEffect, useContext } from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";

import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import FormEnviarHorasExtras from "../../../NominaCuadrosTurnos/ui/components/form-enviar-horas-extras";
import BtnEnviarHorasExtrasContext from "../../../NominaCuadrosTurnos/store/boton-enviar-horas-extras-context";

const BotonEnviarHorasExtras = ({ onHorasExtras }) => {
    const { userCan } = useUser();
    const modalEnviarHorasExtras = useModal();
    const { botonHorasExtras, actualizarBotonHorasExtras } = useContext(
        BtnEnviarHorasExtrasContext
    );

    useEffect(() => actualizarBotonHorasExtras(), []);

    let component = null;

    if (userCan("nominaEnviarHoraExtraGerente") && botonHorasExtras) {
        component = (
            <>
                <Button
                    color="warning"
                    title="Enviar a gerencia"
                    className="ml-2"
                    onClick={() => modalEnviarHorasExtras.open()}
                >
                    <i className="fas fa-clock"></i>
                    <span className="ml-2">Enviar horas a gerencia</span>
                </Button>
                <FormEnviarHorasExtras
                    modalState={modalEnviarHorasExtras}
                    onHorasExtras={onHorasExtras}
                />
            </>
        );
    }

    return <>{component}</>;
};

BotonEnviarHorasExtras.propTypes = {
    onHorasExtras: PropTypes.func,
};

export default BotonEnviarHorasExtras;
